import { db } from "common/config/Firebase";

const notesCollection = db.collection("notes");

const toggleNoteUseCase = async (id, done) => {
  const nextDone = !done;

  return notesCollection.doc(id).update({
    done: nextDone,
    completedAt: nextDone ? Date.now() : null,
  });
};

export default toggleNoteUseCase;